import { DocumentTypeDTO, GuaranteeTypeDTO } from '@/types/models'

export const planDocumentMapper: Record<
  DocumentTypeDTO | GuaranteeTypeDTO,
  string
> = {
  guarantee: 'مستندات تضمین',
  finance: 'تایید نهاد مالی',
  introduction: 'معرفی و ارزیابی کامل طرح',
  contract: 'قرارداد با سرمایه‌‌پذیر',
  performance: 'مستندات تضمین',
  property: 'مستندات تضمین',
  bankPayment: 'مستندات تضمین',
  fundPayment: 'مستندات تضمین',
  security: 'مستندات تضمین',
  gold: 'مستندات تضمین',
  thirdParty: 'مستندات تضمین',
  auditorAcceptance: 'نامه قبول سمت حسابرس',
  companyLicense: 'مجوز شرکت',
}
